import { useEffect } from 'react';

/**
 * مدیریت تگ‌های head بدون کتابخانهٔ اضافه (CRA):
 * تگ‌هایی که این هوک می‌سازد با data-seo-head علامت می‌خورند و هنگام خروج از صفحه حذف می‌شوند.
 */
export interface SeoHeadOptions {
  title?: string;
  description?: string | null;
  canonical?: string | null;
  robots?: string;
  meta?: Array<{ name?: string; property?: string; content: string | null | undefined }>;
  jsonLd?: object | object[] | null;
}

const MARK = 'data-seo-head';

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"][${MARK}]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    el.setAttribute(MARK, '1');
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

export const useSeoHead = (options: SeoHeadOptions, deps: unknown[] = []) => {
  useEffect(() => {
    const previousTitle = document.title;
    if (options.title) document.title = options.title;

    if (options.description) upsertMeta('name', 'description', options.description);
    if (options.robots) upsertMeta('name', 'robots', options.robots);
    (options.meta || []).forEach((m) => {
      if (!m.content) return;
      if (m.name) upsertMeta('name', m.name, m.content);
      if (m.property) upsertMeta('property', m.property, m.content);
    });

    if (options.canonical) {
      let link = document.head.querySelector<HTMLLinkElement>(`link[rel="canonical"][${MARK}]`);
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute(MARK, '1');
        document.head.appendChild(link);
      }
      link.setAttribute('href', options.canonical);
    }

    if (options.jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute(MARK, '1');
      script.text = JSON.stringify(options.jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      document.title = previousTitle;
      document.head.querySelectorAll(`[${MARK}]`).forEach((el) => el.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
